import type {
  Location,
  LocationFeatures,
  LocationFeature,
  LocationFeatureChild
} from '@/location'

export function formattedAddress(location: Location) {
  if (!location?.address) return ''
  return `${location.address.street ?? ''}${
    location.address.zip || location.address.city ? ', ' : ''
  }${location.address.zip ? location.address.zip : ''}${
    location.address.zip && location.address.city ? ' ' : ''
  }${location.address.city ?? ''}${
    location.address.country ? ', ' + location.address.country : ''
  }`
}

/*
export const locationTypes = [
  {
    label: i18n.global.t('location.types.free_parking'),
    value: 'free_parking'
  },
  {
    label: i18n.global.t('location.types.paid_parking'),
    value: 'paid_parking'
  },
  {
    label: i18n.global.t('location.types.safe_parking'),
    value: 'safe_parking'
  },
  {
    label: i18n.global.t('location.types.ranking_position'),
    value: 'ranking_position'
  },
  {
    label: i18n.global.t('location.types.repair_shop'),
    value: 'repair_shop'
  },
  {
    label: i18n.global.t('location.types.toilet'),
    value: 'toilet'
  },
  {
    label: i18n.global.t('location.types.shower'),
    value: 'shower'
  },
  {
    label: i18n.global.t('location.types.store'),
    value: 'store'
  },
  {
    label: i18n.global.t('location.types.laundry'),
    value: 'laundry'
  },
  {
    label: i18n.global.t('location.types.restaurant'),
    value: 'restaurant'
  },
  {
    label: i18n.global.t('location.types.loadingUnloading'),
    value: 'loadingUnloading'
  }
]
*/

export const locationTypes = [
  {
    labelKey: 'location.types.free_parking',
    value: 'parking'
  },
  {
    labelKey: 'location.types.paid_parking',
    value: 'paid_parking'
  },
  {
    labelKey: 'location.facility',
    value: 'facility'
  },
  {
    labelKey: 'filter.label.service',
    value: 'service'
  },
  {
    labelKey: 'filter.places.delivery',
    value: 'loadingUnloading'
  }
]

const openingHoursOnCheck = (
  feature: LocationFeature,
  child: LocationFeatureChild
) => {
  if (!feature.children) return
  if (child.key === '24h') {
    for (const c of feature.children) {
      if (child.key !== c.key) {
        c.checked = false
      }
    }
  } else {
    for (const c of feature.children) {
      if (c.key === '24h') {
        c.checked = false
      } else {
        c.checked = true
      }
    }
  }
}

export const features = {
  openhours: {
    labelKey: 'type.openhours',
    onCheck: (feature: LocationFeature) => {
      if (feature.key === 'allweek') {
        for (const child of features.openhours.children) {
          if (child.key !== feature.key) {
            child.checked = false
          }
        }
      } else {
        for (const child of features.openhours.children) {
          if (child.key === 'allweek') {
            child.checked = false
          }
        }
      }
    },
    children: [
      {
        labelKey: 'location.features.allweek',
        key: 'allweek',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.monday',
        key: 'monday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.tuesday',
        key: 'tuesday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.wednesday',
        key: 'wednesday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.thursday',
        key: 'thursday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.friday',
        key: 'friday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.saturday',
        key: 'saturday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      },
      {
        labelKey: 'location.features.sunday',
        key: 'sunday',
        checked: false,
        onCheck: openingHoursOnCheck,
        children: [
          { labelKey: 'location.features.open_24/7', key: '24h', checked: false },
          {
            labelKey: 'location.features.opens',
            key: 'opens',
            checked: false,
            type: 'time',
            value: '06:00',
            defaultValue: '06:00'
          },
          {
            labelKey: 'location.features.closes',
            key: 'closes',
            checked: false,
            type: 'time',
            value: '21:00',
            defaultValue: '21:00'
          }
        ]
      }
    ]
  },
  comforts: {
    labelKey: 'filter.label.facilities',
    children: [
      {
        labelKey: 'location.features.toilet',
        key: 'toilet',
        icon: 'toilet',
        checked: false,
        children: [
          {
            labelKey: 'location.features.separate_toilet',
            key: 'separate_toilet',
            type: 'icon',
            icon: 'separate_toilet',
            checked: false
          },
          // {
          //   name: i18n.global.t('location.features.amount_toilet_dames'),
          //   key: 'toilet-dames',
          //   type: 'amount',
          //   checked: false,
          //   value: '0',
          //   defaultValue: '0'
          // },
          // {
          //   name: i18n.global.t('location.features.amount_toilet_gents'),
          //   key: 'toilet-gents',
          //   type: 'amount',
          //   checked: false,
          //   value: '0',
          //   defaultValue: '0'
          // },
          // {
          //   name: i18n.global.t('location.features.price'),
          //   key: 'toilet-pay',
          //   type: 'price',
          //   checked: false,
          //   value: null
          // },
          {
            labelKey: 'location.features.code',
            key: 'toilet-code',
            type: 'text',
            placeholder: '0000',
            checked: false,
            value: null
          }
        ]
      },
      {
        labelKey: 'location.features.shower',
        key: 'shower',
        checked: false,
        icon: 'shower'
      },
      {
        labelKey: 'meta.wifi',
        key: 'wifi',
        checked: false,
        icon: 'wifi'
      },
      {
        labelKey: 'meta.el',
        key: 'el',
        checked: false,
        icon: 'el'
      },
      {
        labelKey: 'meta.vatten',
        key: 'vatten',
        checked: false,
        icon: 'vatten'
      },
      {
        labelKey: 'filter.facilities.kitchen',
        key: 'kitchen',
        checked: false,
        icon: 'kitchen'
      },
      {
        labelKey: 'filter.facilities.resting_area',
        key: 'resting_area',
        checked: false,
        icon: 'resting_area'
      }
      // { name: 'Soptunna', key: 'soptunna', checked: false, icon: 'soptunna' }
    ]
  },
  services: {
    labelKey: 'filter.label.service',
    children: [
      {
        labelKey: 'meta.restaurant',
        key: 'restaurant',
        checked: false,
        icon: 'restaurant'
      },
      {
        labelKey: 'meta.store',
        key: 'store',
        checked: false,
        icon: 'store'
      },
      {
        labelKey: 'meta.accommodation',
        key: 'accommodation',
        checked: false,
        icon: 'accommodation',
        children: [
          {
            labelKey: 'location.features.price',
            key: 'accommodation_price',
            checked: false,
            type: 'price',
            value: null
          }
        ]
      },
      {
        labelKey: 'meta.repair_shop',
        key: 'repair_shop',
        checked: false,
        icon: 'repair_shop'
      },
      {
        labelKey: 'meta.truck_cleaning',
        key: 'truck_cleaning',
        checked: false
      }
    ]
  },
  parking_feature: {
    labelKey: 'location.parking_features',
    children: [
      {
        labelKey: 'filter.places.ranking_position',
        key: 'ranking_position',
        checked: false
      }
    ]
  },
  security: {
    labelKey: 'filter.label.security',
    children: [
      {
        labelKey: 'filter.security.adr_allowed',
        key: 'adr_allowed',
        checked: false
      },
      {
        labelKey: 'filter.security.guard.guard',
        key: 'security_guard',
        checked: false
      },
      {
        labelKey: 'filter.security.fence_locked_gate',
        key: 'fence_locked_gate',
        checked: false
      },
      {
        labelKey: 'filter.security.lighted',
        key: 'light_sensor',
        checked: false
      },
      {
        labelKey: 'filter.security.camera',
        key: 'camera',
        checked: false
      },
      {
        labelKey: 'filter.security.alarm',
        key: 'alarm',
        checked: false
      }
    ]
  }
} as LocationFeatures

// accessibility: {
//   name: i18n.global.t('meta.label.accessibility'),
//   children: [
//     {
//       labelKey: 'location.features.truck',
//       key: 'truck-15',
//       checked: true
//     },
//     {
//       labelKey: 'location.features.trailer_truck',
//       key: 'truck-22',
//       checked: false
//     },
//     {
//       labelKey: 'location.features.trailer_truck',
//       key: 'truck-24',
//       checked: false
//     },
//     {
//       labelKey: 'location.features.trailer_truck',
//       key: 'truck-34',
//       checked: false
//     }
//   ]
// }

// export const parkingFeatures = [
//   {
//     labelKey: 'filter.places.ranking_position',
//     key: 'ranking_position',
//     checked: false
//   }
// ]

// export const securityFeatures = [
//   {
//     labelKey: 'filter.security.tt_premium_user_only',
//     key: 'tt_premium_user_only',
//     checked: false,
//     icon: 'my_locations'
//   },
//   {
//     labelKey: 'filter.security.adr_allowed',
//     key: 'adr_allowed',
//     checked: false
//   },
//   {
//     labelKey: 'filter.security.guard.guard',
//     key: 'security_guard',
//     checked: false
//   },
//   {
//     labelKey: 'filter.security.fence_locked_gate',
//     key: 'fence_locked_gate',
//     checked: false
//   },
//   {
//     labelKey: 'filter.security.lighted',
//     key: 'light_sensor',
//     checked: false
//   },
//   {
//     labelKey: 'filter.security.camera',
//     key: 'camera',
//     checked: false
//   },
//   {
//     labelKey: 'filter.security.alarm',
//     key: 'alarm',
//     checked: false
//   }
// ]
